import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 4l3 8l-3 8","key":"svg-0"}]]

const IconChevronCompactRight = createReactComponent('outline', 'chevron-compact-right', 'ChevronCompactRight', __iconNode);

export default IconChevronCompactRight;